import React from 'react'
import { Container } from 'react-bootstrap'
const AboutBus = () => {
  return (
    <section className="_emtabout corp-hidden">
   <Container>
   <div className="_ininety">
      <div className="_Genttl">
        <span>
          {/*Search Flights, Hotels, Bus and Holiday Packages*/}Travel Made Simple: Book Bus Tickets Instantly with Innovate Blues
        </span>
      </div>
      <div className="_abt_txt">
        {/*EaseMyTrip is one of the largest online travel platforms in India, and a trusted name in the Indian travel industry. We offer "end to end" travel solutions including air tickets, hotel booking, cab and bus booking, train tickets and holiday packages. Additionally, we offer ancillary value-added services.*/}
Picture this — you’re all set for that long-awaited road trip across India with your favorite people, kicking off the adventure by bus. There’s a unique thrill in hitting the open road, watching the world unfold outside your window — from lush green landscapes and lively towns to quaint villages and endless horizons. Every moment becomes a story — the laughter shared with friends, heartfelt talks with family, spontaneous detours, and the joy of discovering hidden gems along the way. Whether you’re traveling solo or with loved ones, the road itself becomes a journey filled with unforgettable memories.      </div>
      <div className="_abt_txt">
With Innovate Blues, booking your bus tickets is quick, easy, and completely hassle-free. Enjoy comfortable seats, spacious coaches, and wide route options that make your trip smoother than ever. So, why wait? Book your bus with Innovate Blues today and let every mile bring a new experience to remember.      </div>
     
    </div>
   </Container>
  </section>
  
  )
}

export default AboutBus